<template>
  <div class="px-5 sm:px-6 lg:px-10 py-6">
    <h1 class="text-[22px] sm:text-[24px] leading-7 font-bold text-gray-900 mb-6">
      Admin Logs
    </h1>

    <DynamicTable
      :rows="rows"
      :columns="columns"
      :rowsPerPage="rows.length || 1000"
      :rowsPerPageOptions="[1000]"
      :showHeader="false"
      :showAddButton="false"
      :rowClass="rowClass"
    >
      <template #action="{ value }">
        <span :title="value">{{ value }}</span>
      </template>

      <template #details="{ value }">
        <span :title="value">{{ value }}</span>
      </template>

      <template #date="{ value }">
        <span class="text-gray-700">[{{ value }}]</span>
      </template>

      <template #time="{ value }">
        <span class="text-gray-700">[{{ value }}]</span>
      </template>
    </DynamicTable>
  </div>
</template>

<script>
import DynamicTable from "@/components/DynamicTable.vue";

export default {
  name: "AdminLogsTourism",
  components: { DynamicTable },

  data() {
    return {
      columns: [
        { key: "action_id",   label: "Action ID",   width: "120px" },
        { key: "employee_id", label: "Employee ID", width: "120px" },
        { key: "action",      label: "Action" },
        { key: "details",     label: "Details" },
        { key: "date",        label: "Date",        width: "140px" },
        { key: "time",        label: "Time",        width: "120px" },
      ],
      rows: [],
    };
  },

  created() {
    this.seedDummyRows();
  },

  methods: {
    seedDummyRows() {
      const lorem =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet";
      this.rows = Array.from({ length: 6 }).map((_, i) => ({
        id: i + 1,
        action_id: "000",
        employee_id: "000",
        action: lorem,
        details: lorem,
        date: "2025-01-01",
        time: "12:00",
      }));
    },
    rowClass() {
      return "";
    },
  },
};
</script>

<style scoped>
@reference "tailwindcss";
:deep(td) {
  @apply text-base;
}
</style>
